import {Controller, useFormContext} from "react-hook-form";
import {LocationSelect} from "../../../location-select";
import {useGoogleCalendarConnection} from "../../../../../react-query-hooks/connect-calendar/useGoogleCalendarConnection";
import {useConnectGoogleCalendarAndResume} from "../../../../../utils/google-calendar-resume";
import {SessionLocationFormFieldType} from "./types";
import {ZoomIcon} from "../../../../../pages/dashboard/automations/icons/zoom-icon";
import {useGetIntegrationsStatus} from "../../../../../react-query-hooks/integrations/integrations";

export function SessionLocationFormFields() {
  const {control, watch} = useFormContext<SessionLocationFormFieldType>();
  const integrationsStatusQuery = useGetIntegrationsStatus();
  const {isConnected} = useGoogleCalendarConnection();
  const {connectAndResume, isConnecting} = useConnectGoogleCalendarAndResume();
  const isZoomSelected = watch("callLocation") === "zoom";
  // Show Zoom to coaches who have connected it. Keep it visible if it's already
  // selected (e.g. editing a Zoom session) even if the status hasn't loaded yet.
  const showZoomOption =
    Boolean(integrationsStatusQuery.data?.zoomConnected) || isZoomSelected;

  return (
    <Controller
      control={control}
      name="callLocation"
      render={({field: {onChange, value}}) => (
        <LocationSelect
          value={value as any}
          onChange={onChange}
          calendarConnected={isConnected}
          onConnectCalendar={connectAndResume}
          isConnectingCalendar={isConnecting}
        />
      )}
    />
  );
}
